import { render, staticRenderFns } from "./DepartmentsCard.vue?vue&type=template&id=1975dcde&"
import script from "./DepartmentsCard.vue?vue&type=script&lang=js&"
export * from "./DepartmentsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports